<template>
  <div>
    <div>
      <el-header class="header" :height="toString(pageWidth)">
      </el-header>
      <el-main class="main">
        <div class="content">
          <div class="download">
            <div class="common">
              <div class="icon">
                <img :src="message.in_icon">
              </div>
              <div class="name">
                <p class="name-t">{{message.in_name}}</p>
                <div class="name-info" v-if="!isPassword">
                  <span
                    class="">{{$t('lange.hversion') + "&nbsp;"+ message.in_bsvs +"&nbsp;（Build&nbsp;"+  message.in_bsvs.replace('.','').replace('.','')  + ")"}}</span>
                  <span>{{$t('lange.zsize') + "&nbsp;"+  (message.in_size / 1024 / 1024).toFixed(2) +"MB"}}</span><br>
                  <span>{{$t('lange.updateTime') + "&nbsp;" + timestampToTime2(message.in_updatetime)}}</span>
                </div>
              </div>
              <div class="install_load" v-if="!isPassword && instaling">
                {{$t('lange.instaling')}}
              </div>
              <div class="ios_but" v-if="!isPassword && instalComplete">
                <a @click="downDescribe"
                  v-if="message.in_form == 'iOS' && message.in_super == 0 && message.in_type == 2">{{$t('lange.iosDescribe')}}</a>
                <a @click="downDescribe"
                  v-if="message.in_form == 'iOS' && message.in_super == 1">{{$t('lange.superDescribe')}}</a>
              </div>
              <div class="down_teach" v-if="!isPassword && down_url != 'http://' && down_url != 'https://'">
                <p class="teach_nosuper"
                  v-if="message.in_form == 'iOS' && message.in_super== 0  && message.in_type == 2" @click="opentech">
                  <i class="el-icon-thumb"></i>&nbsp;&nbsp;{{$t('lange.downipa')}}
                </p>
                <p class="teach_super" v-if="message.in_form == 'iOS' && message.in_super== 1" @click="isTeach = true">
                  <i class="el-icon-thumb"></i>&nbsp;&nbsp;{{$t('lange.downsuper')}}
                </p>
              </div>
              <div class="download_but"
                v-if="!isPassword && down_url != 'http://' && down_url != 'https://' && downbut">
                <a @click="downAndroid" v-if="message.in_form == 'Android'&&mobile == 2">
                  <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                </a>
                <a @click="downIpa" v-if="!message.in_super && message.in_form == 'iOS'&&mobile == 1">
                  <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                </a>
                <a @click="downSuper" v-if="message.in_super && message.in_form == 'iOS'&&mobile == 1">
                  <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                </a>
              </div>
              <div class="facility" v-if="!isPassword">
                {{is_merge == "1"?$t('lange.iOSAndroid'):(message.in_form == 'Android'?$t('lange.facilityAndroid'):$t('lange.facilityiPhone'))}}
                <!-- {{message.in_form == 'Android'?$t('lange.facilityAndroid'):$t('lange.facilityiPhone')}} -->
              </div>
              <div class="ewm">
                <vue-qr ref="Qrcode" :text="url" qid="testQrId">
                </vue-qr>
                <div>{{$t('lange.QRcode')}}</div>
              </div>
            </div>
          </div>
          <div class="describe">
            <div class="common">
              <div class="pc-name">
                <p class="pc-name-t">{{message.in_name}}</p>
                <div class="pc-name-info" v-if="!isPassword">
                  <span
                    class="">{{$t('lange.hversion') + "&nbsp;"+ message.in_bsvs +"&nbsp;（Build&nbsp;"+  message.in_bsvs.replace('.','').replace('.','')  + ")"}}</span>
                  <span>{{$t('lange.zsize') + "&nbsp;"+  (message.in_size / 1024 / 1024).toFixed(2) +"MB"}}</span><br>
                  <span>{{$t('lange.updateTime') + "&nbsp;" + timestampToTime2(message.in_updatetime)}}</span>
                </div>
              </div>
              <div class="template-pwd" v-if="isPassword">
                <div class="form-group">
                  <label>{{$t('lange.password')}}</label>
                  <input type="input" id="password" class="form-control" v-model="password">
                </div>
                <div class="top-pwd hidden-sm-and-down">
                  <span class="el-icon-lock iconfont"></span>
                </div>
                <button type="button" class="ms-btn decoding" @click="submitPwd">{{$t('lange.enter')}}</button>
              </div>
              <hr class="hr" v-if="!isPassword">
              <div class="describe-block" v-if="!isPassword">
                <div class="describe-block-t">
                  {{$t('lange.introduce')}}
                </div>
                <p class="describe-block-p" v-html="message.in_appintro ==''?message.in_name:message.in_appintro">
                </p>
              </div>
              <div class="describe-block" v-if="!isPassword && message.in_remark">
                <div class="describe-block-t">
                  {{$t('lange.remark')}}
                </div>
                <p class="describe-block-p">
                  {{message.in_remark}}
                </p>
              </div>
              <!-- <div class="describe-block" v-if="!isPassword">
                <div class="describe-block-t">
                  {{$t('lange.contact')}}
                </div>
                <p class="describe-block-p">
                  33333333333333
                </p>
              </div> -->
            </div>
          </div>

        </div>
      </el-main>
      <el-footer>
        <div class="content">
          <div class="footer">
            <span @click="mianze">{{$t('lange.disclaimer')}}</span><span>&nbsp;&nbsp;</span><span
              @click="showDialog">{{$t('lange.report')}}</span>
          </div>
        </div>
      </el-footer>
    </div>
    <!-- 举报弹窗 -->
    <Dialog :isShow.sync="isShow" :id="id" :appName="appName" @cancel="cancel" v-if="id"></Dialog>
    <Dialogteach :isTeach.sync="isTeach" @closeTeach="closeTeach"></Dialogteach>

  </div>
</template>
<script>
  import TemplaceMixins from '@/mixins/mixin.js'
  export default {
    mixins: [TemplaceMixins],
    data() {
      return {};
    },
  }

</script>
<style scoped>
  .header {
    width: 100vw;
    background: #157df1 url("/static/img/t-04.png") repeat-x center bottom;
    height: 175px;
    z-index: 90;
  }

  .main {
    width: 100vw;
    /* padding-right: 15px;
    padding-left: 15px; */
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }

  .content {
    box-sizing: border-box;
    z-index: 99;
  }

  .download {
    background: url("/static/img/t-05.png") no-repeat center;
    width: 288px;
    height: 568px;
    padding-top: 110px;
  }

  .common {
    padding: 0;
  }

  .icon {
    box-shadow: none;
    width: auto;
    height: auto;
    background-color: transparent;
    display: flex;
    align-items: center;
  }

  .icon img {
    width: 120px;
    height: 120px;
    border-radius: 30px;
    border: 1px solid #e5e5e5;
    margin: 0 auto;
  }

  .name-t {
    margin-top: 5px;
  }

  .top-pwd {
    position: absolute;
    left: 50%;
    top: -30px;
    margin-left: -30px;
    width: 60px;
    height: 60px;
    border: 1px solid #157df1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafafa;
  }

  .template-pwd {
    position: relative;

  }

  .top-pwd .iconfont {
    color: #157df1;
    font-size: 30px;
  }

  .footer {
    margin-top: 140px;
    margin-bottom: 40px;
    padding-bottom: 8px;
    font-size: 12px;
    text-align: center;
  }

  .footer span {
    color: #157df1;
  }

  .pc-name {
    display: none;
  }

  @media (min-width:768px) {

    .header {
      position: absolute;
      z-index: 10;
      top: 0px;
    }

    .main {
      z-index: 90;
      position: relative;
      top: 50px;
      padding: 20px;
      width: 1000px;
    }

    .content {
      position: relative;
      top: -125px;
    }

    .download {
      width: 308px;
      height: 608px;
      margin-top: 125px;
      padding-top: 0px;
      float: left;
    }

    .icon {
      margin-top: 90px;
    }

    .name {
      display: none;
    }

    .download_but {
      text-align: center;
    }

    .download_but a {
      padding: 0 36px;
      margin-bottom: 10px;
      height: 40px;
      line-height: 38px;
      border-radius: 0px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: #157df1;
      display: inline-block;
      text-decoration: none;
    }


    .facility {
      color: #999;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
    }

    .ewm {
      width: 200px;
      overflow: hidden;
      margin: 35px auto 0;
      text-align: center;
      margin-top: 25px;
    }

    .ewm img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
      border: 1px solid #e5e5e5;
    }

    .ewm div {
      color: #999;
      font-size: 14px;
      width: 200px;
      text-align: center;
    }

    .describe {
      float: left;
      margin-left: 40px;
      width: 570px;
      height: 608px;
      margin-top: 125px;
      padding-top: 0px;
    }

    .hr {
      display: none;
    }

    .describe-block-t {
      font-weight: 600;
    }

    .describe-block-p {
      color: #555;
      font-size: 13px;
      font-weight: 400;
      word-wrap: break-word;
    }

    .pc-name {
      display: block;
      height: 120px;
    }

    .pc-name-t {
      font-size: 24px;
      color: #fff;
      margin: 0px;
      line-height: 40px;
    }

    .pc-name-info {
      color: #fff;
    }

    .template-pwd {
      width: auto;
      margin: 80px 0px;
      background-color: #fafafa !important;
      padding: 60px 30px 20px !important;
      height: auto !important;
      border-radius: 5px;
    }

    .form-group {
      text-align: center;
      margin-bottom: 15px;
    }

    .form-group label {
      font-size: 12px;
      display: block;
      margin-bottom: 10px;
    }

    .form-control {
      border-color: #e5e5e5;
      margin-top: 5px;
      height: 28px;
      box-shadow: none;
      border-radius: 5px;
      color: #fff;
      background-color: rgb(59, 59, 59) !important;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      width: 80%;
      border: 1px solid #ccc;
    }

    .decoding {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
      font-size: 15px;
      /* margin-top: 19px;
    margin-bottom: 10px; */
      width: 170px;
      color: #fff;
      background-color: #157df1;
      margin: 19px auto 10px;
      display: block;
      white-space: nowrap;
      vertical-align: middle;
      cursor: pointer;
      border: 1px solid transparent;
    }

    .down_teach {
      text-align: center;
      padding: 10px;
    }

    .down_teach p {
      margin: 0px;
      color: #157df1;
      font-size: 14px;
    }

    .install_load {
      color: #1abc9c;
      text-align: center;
      margin-top: 10px;
    }

    .ios_but {
      text-align: center;
      margin-top: 10px;
    }

    .ios_but a {
      padding: 0 36px;
      margin-bottom: 10px;
      height: 40px;
      width: 120px;
      line-height: 38px;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: #40acf1;
      display: inline-block;
      text-decoration: none;
    }

    .template-footer {
      margin-top: 20px;
    }
  }

  @media (max-width: 767px) {
    .header {
      height: 19vw;
    }

    .content {
      margin-top: 0px;
      padding: 0px;
    }

    .download {
      background-image: none;
      width: 100%;
      height: auto;
      float: none;
      padding-top: .4rem;
    }

    .icon {
      width: 24vw;
      height: 24vw;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      border-radius: 20px;
      margin: 0 auto;
    }

    .icon img {
      width: 60px;
      height: 60px;
      border-radius: 15px;
    }

    .name-t {
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 0;
      margin-top: 15px;
    }

    .name-info {
      text-align: center;
      margin-top: 8px;
      font-size: 14px;
      line-height: 24px;
    }

    .name-info span {
      color: #999;
      margin-right: 10px;
    }

    .download_but {
      text-align: center;
    }

    .download_but a {
      padding: 0 36px;
      margin-bottom: 10px;
      height: 40px;
      line-height: 38px;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: #157df1;
      display: inline-block;
      text-decoration: none;
    }

    .download_but i {
      color: #fff;
    }

    .download_but span {
      color: #fff;
    }

    .facility {
      color: #999;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
    }

    .ewm {
      width: 200px;
      overflow: hidden;
      margin: 35px auto 0;
      text-align: center;
      margin-top: 25px;
    }

    .ewm img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
      border: 1px solid #e5e5e5;
    }

    .ewm div {
      color: #999;
      font-size: 14px;
      width: 200px;
      text-align: center;
    }

    .describe {
      width: 100%;
      margin: 0px;
    }

    .describe .common .hr {
      border-top: 1px solid rgb(39, 39, 39);
      border-top-color: #e5e5e5;
      margin-top: 25px;
    }

    .describe-block {
      margin-top: 0;
      margin-bottom: 20px;
      width: 100%;
    }

    .describe-block-t {
      font-size: 16px;
      color: #333;
      margin-top: 25px;
      font-weight: 600;
      margin-bottom: 5px;
    }

    .describe-block-p {
      color: #555;
      font-size: 13px;
      font-weight: 400;
      /* overflow: auto; */
      width: 100%;
      word-wrap: break-word;
    }

    .describe-block-p p {
      max-width: 100%;
    }

    .footer {
      margin-top: 20px;
    }

    .template-pwd {
      width: auto !important;
      margin: 30px 35px 0;
      background-color: #fff !important;
      box-shadow: 0 0 10px rgba(0, 0, 0, 10%);
      padding: 10px 20px !important;
      height: auto !important;
      border-radius: 5px;
    }

    .form-group {
      text-align: center;
      margin-bottom: 15px;
    }

    .form-group label {
      font-size: 12px;
    }

    .form-control {
      border-color: #e5e5e5;
      margin-top: 5px;
      height: 28px;
      box-shadow: none;
      border-radius: 5px;
      color: #fff;
      background-color: rgb(59, 59, 59) !important;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      width: inherit;
      border: 1px solid #ccc;
    }

    .decoding {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
      font-size: 15px;
      /* margin-top: 19px;
      margin-bottom: 10px; */
      width: 170px;
      color: #fff;
      background-color: #157df1;
      margin: 19px auto 10px;
      display: block;
      white-space: nowrap;
      vertical-align: middle;
      cursor: pointer;
      border: 1px solid transparent;
    }

    .down_teach {
      text-align: center;
      padding: 15px;
    }

    .down_teach p {
      margin: 0px;
      color: #157df1;
      font-size: 14px;
    }

    .install_load {
      color: #1abc9c;
      text-align: center;
      margin-top: 10px;
    }

    .ios_but {
      text-align: center;
      margin-top: 10px;
    }

    .ios_but a {
      padding: 0 36px;
      margin-bottom: 10px;
      height: 40px;
      width: 200px;
      line-height: 38px;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: #40acf1;
      display: inline-block;
      text-decoration: none;
    }

    .top-pwd {
      display: none !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TemplateOne.vue